const DEFAULT_NUMBER_PRECISION = 2;
export const formatNumberToPrecision = (number, precision) =>
  number ? number.toFixed(precision ?? DEFAULT_NUMBER_PRECISION) : "";
